import { Box, themeColor, styles } from '@elparking/components'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const SectionContainer = styled(Box)`
    ${styles.background}
    border: 1px solid ${themeColor('gray30')};
    border-radius: 4px;
    background-size: cover;
    background-position: center;
    box-shadow: ${({ withShadow }) => withShadow ? '0px 2px 8px 0px rgba(0,0,0,0.1)' : 'none'};
`

SectionContainer.propsTypes = {
    withShadow: PropTypes.bool,
}

export default SectionContainer
